import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";

const initialState = {
    chats: [],
    messages: [],
};

const endpoint = process.env.NEXT_PUBLIC_BASE_URL
const version = process.env.NEXT_PUBLIC_URL_VERSION

export const createGroupWithFollowers = createAsyncThunk(
    "chatSlice/createGroupWithFollowers",
    async ({ token, router }) => {
        try {
            console.log(token, 'token slice')
            const { data } = await axios.post(`${endpoint}${version}/public/chat/group-from-followers`, {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            console.log(data)
            if (data.success) {
                toast.success(data.message, { duration: 2000 });
                router.push('/inbox')
                return data
            }
        } catch (error) {
            if (
                error.response &&
                error.response.data.message === "Group already exists"
            ) {
                toast.error("Group already exists", { duration: 2000 });
                router.push("/inbox");
            } else {
                toast.error("Error creating group", { duration: 2000 });
            }
            return console.error(error.message);
        }
    }
);

export const sendMessage = createAsyncThunk(
    "chatSlice/sendMessage",
    async ({ token, chatId, content }) => {
        try {
            console.log(token, 'token slice')
            const { data } = await axios.post(`${endpoint}${version}/public/chat/message`, {
                chatId,
                content
            },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            console.log(data)
            return data?.message;
        } catch (error) {
            toast.error("Error sending message", { duration: 2000 });
            return console.error(error.message);
        }
    }
);

export const makeAdmin = createAsyncThunk(
    "chatSlice/makeAdmin",
    async ({ token, chatId, memberId }) => {
        try {
            console.log(token, 'token slice')
            const { data } = await axios.post(`${endpoint}${version}/public/chat/make-admin`, {
                chatId,
                memberId
            },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            console.log(data)
            toast.success(data?.message, { duration: 2000 })
            return data?.message;
        } catch (error) {
            const errMsg =
                error.response?.data?.message || "Something went wrong while making admin";
            toast.error(errMsg, { duration: 2000 });
            return console.error(error.message);
        }
    }
);

export const removeAdmin = createAsyncThunk(
    "chatSlice/removeAdmin",
    async ({ token, chatId, memberId }) => {
        try {
            console.log(token, 'token slice')
            const { data } = await axios.post(`${endpoint}${version}/public/chat/remove-admin`, {
                chatId,
                memberId
            },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            console.log(data)
            toast.success(data?.message, { duration: 2000 })
            return data?.message;
        } catch (error) {
            const errMsg =
                error.response?.data?.message || "Something went wrong while removing admin";
            toast.error(errMsg, { duration: 2000 });
            return console.error(error.message);
        }
    }
);

export const getUserChats = createAsyncThunk(
    "chatSlice/getUserChats",
    async ({ token, setLoading }) => {
        try {
            setLoading(true)
            console.log(token, 'token')
            const { data } = await axios.get(`${endpoint}${version}/public/chat`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            console.log(data)
            if (data.success) {
                return data?.chats
            }
        } catch (error) {
            toast.error("Error fetching chats", { duration: 2000 });
            return console.error(error.message);
        } finally {
            setLoading(false)
        }
    }
);

export const getMessages = createAsyncThunk(
    "chatSlice/getMessages",
    async ({ token, setLoading, chatId }) => {
        try {
            setLoading(true)
            console.log(token, 'token')
            const { data } = await axios.get(`${endpoint}${version}/public/chat/message/${chatId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            console.log(data)
            if (data.success) {
                return data?.messages
            }
        } catch (error) {
            toast.error("Error fetching chats", { duration: 2000 });
            return console.error(error.message);
        } finally {
            setLoading(false)
        }
    }
);

const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        addMessage: (state, action) => {
            const exists = state.messages.find(m => m._id === action.payload._id);
            if (!exists) {
                state.messages.push(action.payload);
            }
        },
        updateChatLatestMessage: (state, action) => {
            const { chatId, message } = action.payload;
            const chat = state.chats.find(c => c._id === chatId);
            if (chat) {
                chat.latestMessage = message;
                chat.updatedAt = message.createdAt;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getUserChats.fulfilled, (state, action) => {
            state.chats = action.payload || [];
        })
        builder.addCase(getMessages.fulfilled, (state, action) => {
            state.messages = action.payload || [];
        })
        // builder.addCase(sendMessage.fulfilled, (state, action) => {
        //     if (action.payload) {
        //         state.messages.push(action.payload);
        //     }
        // })
        builder.addCase(sendMessage.fulfilled, (state, action) => {
            if (action.payload) {
                const newMsg = action.payload;

                // ✅ Messages array update
                // state.messages.push(newMsg);

                // ✅ Sidebar chats update
                const chatIndex = state.chats.findIndex((c) => c._id === newMsg.chat._id);
                if (chatIndex > -1) {
                    // update latest message + updatedAt
                    state.chats[chatIndex].latestMessage = newMsg;
                    state.chats[chatIndex].updatedAt = new Date();

                    // chat ko top pe le aao
                    const updatedChat = state.chats[chatIndex];
                    state.chats.splice(chatIndex, 1);
                    state.chats.unshift(updatedChat);
                }
            }
        });
    }
});

export const { addMessage, updateChatLatestMessage } = chatSlice.actions;
export default chatSlice.reducer;
